import React, { ReactNode } from 'react'
import { StyledTransitionGroup } from './styled-transition-group'

interface TransitionUnorderedListProps {
  readonly children: ReactNode
  readonly className?: string
}

export function TransitionUnorderedList({
  children,
  className
}: TransitionUnorderedListProps) {
  return (
    <StyledTransitionGroup
      component="ul"
      className={className}
      children={children}
    />
  )
}
